var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgGooglePlay = function SvgGooglePlay(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 48,
    viewBox: "0 0 168 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 48,
    rx: 4,
    fill: "#1B1B1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.600543 4.94808C0.907185 3.37041 1.8945 2.04407 3.27583 1.26087C1.91666 2.05904 0.915747 3.38841 0.600543 4.94808ZM3.27578 46.7391C1.89448 45.9559 0.907183 44.6296 0.600544 43.0519C0.915745 44.6116 1.91664 45.9409 3.27578 46.7391ZM167.4 43.0515C167.093 44.6293 166.106 45.9558 164.724 46.7391C166.083 45.9408 167.084 44.6113 167.4 43.0515Z",
    stroke: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 11.9602C60 12.9202 59.76 13.7602 59.16 14.3602C58.44 15.0802 57.6 15.4402 56.52 15.4402C55.44 15.4402 54.6 15.0802 53.88 14.3602C53.16 13.6402 52.8 12.8002 52.8 11.7202C52.8 10.6402 53.16 9.80024 53.88 9.08024C54.6 8.36024 55.44 8.00024 56.52 8.00024C57 8.00024 57.48 8.12025 57.96 8.36025C58.44 8.60025 58.8 8.84024 59.04 9.20024L58.44 9.80024C57.96 9.20024 57.36 8.96025 56.52 8.96025C55.8 8.96025 55.08 9.20024 54.6 9.80024C54 10.2802 53.76 11.0002 53.76 11.8402C53.76 12.6802 54 13.4002 54.6 13.8802C55.2 14.3602 55.8 14.7202 56.52 14.7202C57.36 14.7202 57.96 14.4802 58.56 13.8802C58.92 13.5202 59.16 13.0402 59.16 12.4402H56.52V11.6002H60C60 11.6002 60 11.8402 60 11.9602Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.52 8.96012H62.28V11.2401H65.28V12.0801H62.28V14.3601H65.52V15.3201H61.32V8.12012H65.52V8.96012Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.48 15.3201H68.52V8.96012H66.48V8.12012H71.52V8.96012H69.48V15.3201Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75 15.3201V8.12012H75.96V15.3201H75Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0399 15.3201H79.08V8.96012H77.0399V8.12012H81.9599V8.96012H79.9199V15.3201H80.0399Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.44 14.36C90.72 15.08 89.88 15.44 88.8 15.44C87.72 15.44 86.88 15.08 86.16 14.36C85.44 13.64 85.08 12.8 85.08 11.72C85.08 10.64 85.44 9.8 86.16 9.08C86.88 8.36 87.72 8 88.8 8C89.88 8 90.72 8.36 91.44 9.08C92.16 9.8 92.52 10.64 92.52 11.72C92.52 12.8 92.16 13.64 91.44 14.36ZM86.88 13.76C87.36 14.24 88.08 14.6 88.8 14.6C89.52 14.6 90.24 14.36 90.72 13.76C91.2 13.28 91.56 12.56 91.56 11.72C91.56 10.88 91.32 10.16 90.72 9.68C90.24 9.2 89.52 8.84 88.8 8.84C88.08 8.84 87.36 9.08 86.88 9.68C86.4 10.16 86.04 10.88 86.04 11.72C86.04 12.56 86.28 13.28 86.88 13.76Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.84 15.3201V8.12012H94.92L98.4 13.7601V12.3201V8.12012H99.36V15.3201H98.4L94.68 9.44012V10.8801V15.3201H93.84Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.84 25.8805C81.96 25.8805 79.68 28.0405 79.68 31.0405C79.68 33.9205 81.96 36.2005 84.84 36.2005C87.72 36.2005 90 34.0405 90 31.0405C90 27.9205 87.72 25.8805 84.84 25.8805ZM84.84 34.0405C83.28 34.0405 81.96 32.7205 81.96 30.9205C81.96 29.1205 83.28 27.8005 84.84 27.8005C86.4 27.8005 87.72 29.0005 87.72 30.9205C87.72 32.7205 86.4 34.0405 84.84 34.0405ZM73.68 25.8805C70.8 25.8805 68.52 28.0405 68.52 31.0405C68.52 33.9205 70.8 36.2005 73.68 36.2005C76.56 36.2005 78.84 34.0405 78.84 31.0405C78.84 27.9205 76.56 25.8805 73.68 25.8805ZM73.68 34.0405C72.12 34.0405 70.8 32.7205 70.8 30.9205C70.8 29.1205 72.12 27.8005 73.68 27.8005C75.24 27.8005 76.56 29.0005 76.56 30.9205C76.56 32.7205 75.24 34.0405 73.68 34.0405ZM60.36 27.4405V29.6005H65.52C65.4 30.8005 64.92 31.7605 64.32 32.3605C63.6 33.0805 62.4 33.9205 60.36 33.9205C57.12 33.9205 54.72 31.4005 54.72 28.1605C54.72 24.9205 57.24 22.4005 60.36 22.4005C62.04 22.4005 63.36 23.1205 64.32 23.9605L65.88 22.4005C64.56 21.2005 62.88 20.2405 60.48 20.2405C56.16 20.2405 52.44 23.8405 52.44 28.1605C52.44 32.4805 56.16 36.0805 60.48 36.0805C62.88 36.0805 64.56 35.3605 66 33.8005C67.44 32.3605 67.92 30.3205 67.92 28.7605C67.92 28.2805 67.92 27.8005 67.8 27.4405H60.36ZM114.84 29.1205C114.36 27.9205 113.16 25.8805 110.52 25.8805C107.88 25.8805 105.72 27.9205 105.72 31.0405C105.72 33.9205 107.88 36.2005 110.76 36.2005C113.04 36.2005 114.48 34.7605 114.96 33.9205L113.28 32.7205C112.68 33.5605 111.96 34.1605 110.76 34.1605C109.56 34.1605 108.84 33.6805 108.24 32.6005L115.08 29.7205L114.84 29.1205ZM107.88 30.8005C107.88 28.8805 109.44 27.8005 110.52 27.8005C111.36 27.8005 112.2 28.2805 112.44 28.8805L107.88 30.8005ZM102.24 35.7205H104.52V20.7205H102.24V35.7205ZM98.64 26.9605C98.04 26.3605 97.08 25.7605 95.88 25.7605C93.36 25.7605 90.96 28.0405 90.96 30.9205C90.96 33.8005 93.24 35.9605 95.88 35.9605C97.08 35.9605 98.04 35.3605 98.52 34.7605H98.64V35.4805C98.64 37.4005 97.56 38.4805 95.88 38.4805C94.56 38.4805 93.6 37.5205 93.36 36.6805L91.44 37.5205C92.04 38.8405 93.48 40.5205 96 40.5205C98.64 40.5205 100.8 38.9605 100.8 35.2405V26.1205H98.64V26.9605ZM96 34.0405C94.44 34.0405 93.12 32.7205 93.12 30.9205C93.12 29.1205 94.44 27.8005 96 27.8005C97.56 27.8005 98.76 29.1205 98.76 30.9205C98.76 32.7205 97.56 34.0405 96 34.0405ZM125.28 20.7205H119.88V35.7205H122.16V30.0805H125.28C127.8 30.0805 130.2 28.2805 130.2 25.4005C130.2 22.5205 127.8 20.7205 125.28 20.7205ZM125.4 27.9205H122.16V22.7605H125.4C127.08 22.7605 128.04 24.2005 128.04 25.2805C127.92 26.6005 126.96 27.9205 125.4 27.9205ZM139.2 25.7605C137.52 25.7605 135.84 26.4805 135.24 28.0405L137.28 28.8805C137.76 28.0405 138.48 27.8005 139.32 27.8005C140.52 27.8005 141.6 28.5205 141.72 29.7205V29.8405C141.36 29.6005 140.4 29.2405 139.44 29.2405C137.28 29.2405 135.12 30.4405 135.12 32.6005C135.12 34.6405 136.92 35.9605 138.84 35.9605C140.4 35.9605 141.12 35.2405 141.72 34.5205H141.84V35.7205H144V29.9605C143.76 27.3205 141.72 25.7605 139.2 25.7605ZM138.96 34.0405C138.24 34.0405 137.16 33.6805 137.16 32.7205C137.16 31.5205 138.48 31.1605 139.56 31.1605C140.52 31.1605 141 31.4005 141.6 31.6405C141.36 33.0805 140.16 34.0405 138.96 34.0405ZM151.56 26.1205L149.04 32.6005H148.92L146.28 26.1205H143.88L147.84 35.2405L145.56 40.2805H147.84L153.96 26.1205H151.56ZM131.4 35.7205H133.68V20.7205H131.4V35.7205Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 8.72046C15.24 9.08046 15 9.68046 15 10.4005V36.9205C15 37.6405 15.24 38.2405 15.6 38.6005L15.72 38.7205L30.6 23.8405V23.7205V23.6005L15.6 8.72046Z",
    fill: "url(#paint0_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.52 28.8799L30.6 23.9599V23.7199V23.5999L35.52 18.6799L35.64 18.7999L41.52 22.1599C43.2 23.1199 43.2 24.6799 41.52 25.6399L35.52 28.8799Z",
    fill: "url(#paint1_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.64 28.7605L30.6 23.7205L15.6 38.7205C16.2 39.3205 17.04 39.3205 18.12 38.8405L35.64 28.7605Z",
    fill: "url(#paint2_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.64 18.6802L18.12 8.72015C17.04 8.12015 16.2 8.24015 15.6 8.84015L30.6 23.7202L35.64 18.6802Z",
    fill: "url(#paint3_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.52 28.6401L18.12 38.4801C17.16 39.0801 16.32 38.9601 15.72 38.4801L15.6 38.6001L15.72 38.7201C16.32 39.2001 17.16 39.3201 18.12 38.7201L35.52 28.6401Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M15.6 38.48C15.24 38.12 15.12 37.52 15.12 36.8V36.92C15.12 37.64 15.36 38.24 15.72 38.6V38.48H15.6Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M41.52 25.2805L35.52 28.6405L35.64 28.7605L41.52 25.4005C42.36 24.9205 42.72 24.3205 42.72 23.7205C42.72 24.3205 42.24 24.8005 41.52 25.2805Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M18.12 8.84017L41.52 22.1602C42.24 22.6402 42.72 23.1202 42.72 23.7202C42.72 23.1202 42.36 22.5202 41.52 22.0402L18.12 8.72017C16.44 7.76017 15.12 8.60017 15.12 10.5202V10.6402C15.12 8.72017 16.44 7.88017 18.12 8.84017Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 29.2796,
    y1: 10.1721,
    x2: 9.14076,
    y2: 30.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 43.7213,
    y1: 23.7216,
    x2: 14.685,
    y2: 23.7216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 32.9124,
    y1: 26.4758,
    x2: 5.60245,
    y2: 53.7857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 11.8768,
    y1: -0.0684059,
    x2: 24.0719,
    y2: 12.1266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGooglePlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-play.19466fbb.svg";
export { ForwardRef as ReactComponent };